module.exports = __webpack_public_path__ + "static/img/default.7ffb648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = jY2U
// module chunks = 1